<template>
  <Layout>
    <Jumbotron :authorizationLink="authorizationLink" :title="$t('use_data')" />
    <Cards :authorizationLink="authorizationLink" />
    <Infographic />
    <JumbotronSmall :authorizationLink="authorizationLink" />
  </Layout>
</template>

<script>
import { localizedLink, orgConfig } from "@/mixins";
import Jumbotron from "@/components/homepage/Jumbotron";
import JumbotronSmall from "@/components/homepage/JumbotronSmall";
import Cards from "@/components/homepage/Cards";
import Infographic from "@/components/homepage/Infographic";
import { getMeta } from "@/helpers/MetaHelper";

export default {
  mixins: [localizedLink, orgConfig],
  components: {
    Jumbotron,
    JumbotronSmall,
    Cards,
    Infographic
  },
  computed: {
    authorizationLink() {
      return { name: "documentation", hash: "section/Authentication" };
    }
  },
  metaInfo() {
    return getMeta(this, this.$t("title"), this.$t("description"));
  }
};
</script>
